import { useTranslation } from 'react-i18next';

import { useCurrentNavigationValues } from '../../../../../../../contents';
import { ProgressCounter } from '../../../../../../../reports';
import type {
  Participation,
  Status,
} from '../../../../../../modules/test/test';
import { TEST_STATUS } from '../../../../../../modules/test/test';

type Props = {
  participation: Participation | null | undefined;
  status: Status;
};

function TestParticipationCell({ participation, status }: Props): JSX.Element {
  const { t } = useTranslation();
  const { currentClassroom } = useCurrentNavigationValues();

  return (
    <ProgressCounter
      completed={participation?.completed || 0}
      total={currentClassroom?.numberOfStudents || 0}
      text={t('testsAndResultsView.table.total-participation')}
      rowIsNull={
        status !== TEST_STATUS.STARTED && status !== TEST_STATUS.COMPLETED
      }
    />
  );
}

export { TestParticipationCell };
